import { BranchCircuit } from './electrical/BranchCircuit';

export enum SensorStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Maintenance = 'MAINTENANCE',
  Pending = 'PENDING',
}

export enum SensorType {
  AIR_QUALITY = 'AIR_QUALITY',
  CO2 = 'CO2',
  ELECTRICAL = 'ELECTRICAL',
  HUMIDITY = 'HUMIDITY',
  HVAC_CONDENSER_MONITOR = 'HVAC_CONDENSER_MONITOR',
  HVAC_AIRHANDLER_MONITOR = 'HVAC_AIRHANDLER_MONITOR',
  LEAK_DETECTOR = 'LEAK_DETECTOR',
  LIGHT = 'LIGHT',
  PM10 = 'PM10',
  PM25 = 'PM25',
  POWER = 'POWER_MONITOR',
  POWER_ALT = 'POWER',
  PRESSURE = 'PRESSURE',
  TEMPERATURE = 'TEMPERATURE',
  VOC = 'VOC',
  WATER_QUALITY = 'WATER_QUALITY',
  MOTION = 'MOTION',
  OTHER = 'OTHER',
  
  // CT sensors are used to measure current transformer values
  HVAC_CONDENSER_MONITOR_CT = 'HVAC_CONDENSER_MONITOR_CT',
  HVAC_AIRHANDLER_MONITOR_CT = 'HVAC_AIRHANDLER_MONITOR_CT',

  // legacy alias for HVAC_AIRHANDLER_MONITOR
  HVAC = 'HVAC_AIRHANDLER_MONITOR',
}

export interface Sensor {
  id: string;
  hubId: string;
  serialNumber: string;
  dsk: string;
  type: string;
  version: string;
  name: string;
  location: string;
  sublocation?: string;
  status: SensorStatus;
  lastReported: number;
  branchCircuits?: BranchCircuit[];
  groupId?: string;
  sensorGroupConfiguration?: SensorGroupSensorConfiguration;
  targetStaticPressure?: number;
  startingStaticPressure?: number;
}

export interface CreateSensorInput {
  id?: string;
  hubId: string;
  serialNumber: string;
  dsk: string;
  type: string;
  version: string;
  name: string;
  location: string;
  sublocation?: string;
  status: SensorStatus;
  lastReported?: number;
  equipmentDetails?: SensorEquipmentDetailsInput;
  branchCircuits?: BranchCircuit[];
  targetStaticPressure?: number;
  startingStaticPressure?: number;
}

export interface UpdateSensorInput {
  id: string;
  serialNumber?: string;
  dsk?: string;
  type?: string;
  version?: string;
  name?: string;
  location?: string;
  sublocation?: string;
  status?: SensorStatus;
  targetStaticPressure?: number;
  startingStaticPressure?: number;
}

export interface UpdateSensorBranchCircuitsInput {
  id: string;
  branchCircuits: BranchCircuit[];
}

export interface LinkSensorInput {
  sensorIds: string[];
  groupId: string;
}

export interface CreateSensorGroupInput {
  groupId?: string;
  sensors: {
    id: string;
    configuration: {
      indoor: boolean;
      metadata?: any;
    };
  }[];
}

export interface SensorEquipmentDetailsInput {
  type?: string;
  systemAge?: string;
  manufacturingDate?: string;
  manufacturer?: string;
  brand?: string;
  model?: string;
  serialNumber?: string;
  warrantyDuration?: string;
  notes?: string;
  photos?: SensorEquipmentPhotoInput;
  airFilterConfiguration?: AirFilterConfiguration;
  pressureConfiguration?: PressureConfiguration;
  systemType?: string;
  coolingLoad?: string;
  heatingLoad?: string;
  staticPressureLimit?: string;
  make?: string;
}

interface SensorEquipmentPhotoInput {
  url: string;
}

export interface AirFilterConfiguration {
  manufacturer: string;
  modelNumber?: string;
  mervRated: boolean;
  mervRating?: string;
  filterSizeHeight: string;
  filterSizeWidth: string;
  filterSizeDepth: string;
  filterMaterial?: string;
  systemType: string;
}

export interface PressureConfiguration {
  staticPressureTarget: string;
  supplyStaticPressure: string;
  returnStaticPressure: string;
  filterPressureDrop: string;
  triggerAlertOnPressure: string;
}

export interface SensorGroupSensorConfiguration {
  indoor: boolean;
  metadata?: any;
}
